// Per-event "don't warn me again about automation field overwrites" preference.
//
// The workflow-overwrite dialog ({@link WorkflowOverwriteDialog}) fires on every
// guest save whose fields an enabled automation (UPDATE_GUEST) will change. Power
// users who know their automations find the repeated confirm noisy, so they can
// dismiss it — but only for the event they're working in (an admin opting out on
// one event must NOT suppress the warning on another where they may not know the
// automations). Scoping the key by eventId keeps it isolated.
//
// Backed by the shared localStorage pref store (this SPA has no server-side
// prefs), mirroring {@link wizardIntroPref}. Best-effort: SSR / private mode /
// a missing eventId all fall back to SHOWING the warning — the safe default,
// since this gates a data-changing save.

import { getPref, setPref, removePref } from "@/lib/storage/userPrefs";

function keyFor(eventId: string): string {
  return `workflow-overwrite-warn-hidden:${eventId}`;
}

export function isWorkflowOverwriteWarnHidden(eventId: string | undefined): boolean {
  if (!eventId) return false;
  return getPref(keyFor(eventId)) === "1";
}

export function setWorkflowOverwriteWarnHidden(eventId: string | undefined): void {
  if (!eventId) return;
  setPref(keyFor(eventId), "1");
}

export function clearWorkflowOverwriteWarnHidden(eventId: string | undefined): void {
  if (!eventId) return;
  removePref(keyFor(eventId));
}
